import React from "react";
import requireAuth from "../auth/requireAuth";
import UserTableGrid from "./UserTableGrid";

class UserList extends React.Component {
  render() {
    return (
      <div className="ui centered grid">
        <div className="ui fifteen wide column">
          <UserTableGrid />
        </div>
      </div>
    );
  }
}

export default requireAuth(UserList);
